import React, { useState, useEffect } from "react";
import "./ProductsSearch.css";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import Alert from "../../../Components/Alert/Alert";
import { useNavigate, useLocation } from "react-router-dom";
import { MdSearch } from "react-icons/md";
import ShopCard from "../../../Components/ShopCard/ShopCard";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import { useBaseUrl } from "../../../ApiContext";

export default function ProductsSearch() {
  const navigate = useNavigate();
  const baseUrl = useBaseUrl();
  const location = useLocation();
  const { label, categorySlug } = location.state || {};
  const { userToken } = useAuth();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [searchInputVal, setSearchInputVal] = useState("");
  const [hasFilter, setHasFilter] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [attrString, setAttrString] = useState("");
  const [priceAttrString, setPriceAttrString] = useState("");

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const handleSearch = async (e) => {
    let inputValue = e.target.value;
    localStorage.setItem("product search value", inputValue);
    setSearchInputVal(inputValue);
  };

  useEffect(() => {
    const fetchSearch = async () => {
      try {
        let response;
        if (label === "products") {
          response = await Axios.get(
            `${baseUrl}/shop/digikala/${categorySlug}/product-varients/search?s=${searchInputVal}${
              (attrString || priceAttrString) && `&attributes=`
            }${attrString}${
              attrString && priceAttrString && `,`
            }${priceAttrString}`,
            {
              headers: {
                Authorization: `Token ${userToken}`,
              },
            }
          );
        } else {
          response = await Axios.get(
            `${baseUrl}/shop/digikala/products/search?s=${searchInputVal}`,
            {
              headers: {
                Authorization: `Token ${userToken}`,
              },
            }
          );
        }
        if (searchInputVal) {
          setSearchResults(response.data.products);
        }
        if (response.data.products.length === 0) {
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
          setAlertText("موردی یافت نشد");
        }
      } catch (error) {
        console.log("Error during getting search result", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    };
    if (userToken) {
      fetchSearch();
    }
  }, [baseUrl, userToken, searchInputVal]);

  const handleFilterClick = () => {
    navigate("/productFilter", {
      state: { categorySlug },
    });
  };

  const handleProductClick = (product) => {
    navigate("/product", {
      state: { baseId: product.base_product_id, productId: product.id },
    });
  };

  useState(() => {
    const storedSearchValue = localStorage.getItem("product search value");
    const storedAttrStringJSON = localStorage.getItem("attribute filters");
    const storedPriceStringJSON = localStorage.getItem("price filters");
    if (storedAttrStringJSON || storedPriceStringJSON) {
      setHasFilter(true);
    }
    if (storedAttrStringJSON) {
      setAttrString(storedAttrStringJSON);
    }
    if (storedPriceStringJSON) {
      setPriceAttrString(storedPriceStringJSON);
    }
    if (storedSearchValue) {
      setSearchInputVal(storedSearchValue);
    }
  }, []);

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <div className="productsSearchHeaderRight centeredFlex">
              <BackBtn />
              {label === "products" && (
                <div className="filterIconWrapper">
                  {hasFilter && <div className="hasFilterBullet"></div>}
                  <img
                    src="/images/filter.svg"
                    alt="filter"
                    className="filterBarIcon"
                    onClick={handleFilterClick}
                  />
                </div>
              )}
            </div>
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <h3 className="pageTitle partialProductsHeading">جستجو محصول</h3>
          <div className="searchContainer responsiveWidth">
            <input
              type="search"
              placeholder="محصول مورد نظر خود را جستجو کنید"
              className="searchInput"
              value={searchInputVal}
              onChange={handleSearch}
            />
            <MdSearch className="searchIcon" />
          </div>
          <div className="magazines responsiveWidth scroll centeredFlex shopSearchResults">
            {searchResults &&
              searchResults.length > 0 &&
              searchResults.map((product) => (
                <ShopCard
                  key={product.id}
                  label="partialProduct"
                  {...product}
                  onShopCardClick={() => handleProductClick(product)}
                />
              ))}
          </div>
          <Alert showAlert={showAlert} alertText={alertText} />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
